<template>
    <div style="position: absolute;" :style="{ right: right + 'px', top: top + 'px', left: left + 'px', bottom: bottom + 'px' }">
        <div @click.stop="closeAction" :style="{ zIndex: zIndex }" style="width: 100%; position: fixed; top: 0; left: 0; height: 100%;"></div>
        <div :style="{ alignItems: center ? '' : 'flex-start', zIndex: popMenuZIndex, maxHeight : maxHeight !== '' ? maxHeight : '',  overflow : maxHeight !== '' ? 'auto' : '', width : width }" style="position: relative; box-shadow: 0px 0px 10px 0px #210F030D; border-radius: 12px; background-color: #fff; ">
            <div v-for="each, i in labelAndAction" :key="i" @click.stop="each.action" style="white-space: nowrap; padding: 12px 15px; display: flex; align-items: center; gap: 8px;" :style="{ borderBottom: i !== labelAndAction.length - 1 ? '1px solid #f5f5f5' : '' }">
                <img :style="{width: each.imageWidth + 'px'}" :src="each.imagePath" alt="">
                <div :style="{color: each.fontColor ? each.fontColor : ''}" style="font-size: 14px; font-weight: 500;">{{ each.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MemberTalkPopMenuOption',
    props: {
        labelAndAction: {
            type: Array,
            default: () => { }
        },
        closeAction: {
            type: Function,
            default: () => { }
        },
        right: {
            type: Number,
            default: null,
        },
        bottom: {
            type: Number,
            default: null,
        },
        top: {
            type: Number,
            default: null,
        },
        left: {
            type: Number,
            default: null,
        },
        center: {
            type: Boolean,
            default: true
        },
        zIndex: {
            type: Number,
            default: 10
        },
        popMenuZIndex: {
            type: Number,
            default: 20
        },
        maxHeight : {
            type : String,
            default : ''
        },
        width : {
            type : String,
            default : '250px'
        }

    },
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}
</style>